import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./ViewDeal.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewDeal } from "../../Redux/Actions/dealsAction";

const ViewDeal = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { deal, loading, error } = useSelector((state) => state.deals || {});

  useEffect(() => {
    if (id) dispatch(viewDeal(id));
  }, [dispatch, id]);

  const data = deal?.data;

  if (loading) return <MainLayout><p className="loading">Loading deal...</p></MainLayout>;
  if (error) return <MainLayout><p className="error">Error: {error}</p></MainLayout>;
  if (!data) return <MainLayout><p className="empty">No deal data available</p></MainLayout>;

  return (
    <MainLayout>
      <div className="deal-main-container">
        <div className="deal-container">
          <h1 className="deal-title">{data.name}</h1>

          <img src={data.image} alt="Deal" className="deal-image" />

          <div className="deal-card">
            <h2>Builder Information</h2>
            <div className="deal-info-group">
              <p><strong>Brand Name:</strong> {data.builder?.brand_name}</p>
              <p><strong>Organization:</strong> {data.builder?.organization_name}</p>
              <p><strong>RERA ID:</strong> {data.builder?.rera_id}</p>
            </div>
          </div>

          <div className="deal-card">
            <h2>Project Information</h2>
            <div className="deal-info-group">
              <p><strong>Project Name:</strong> {data.project?.project_name}</p>
              <p><strong>Brand:</strong> {data.project?.brand_name}</p>
              <p><strong>Project ID:</strong> {data.project?.project_id}</p>
              <p><strong>RERA ID:</strong> {data.project?.rera_id}</p>
            </div>
          </div>

          <div className="deal-card">
            <h2>Discount Info</h2>
            <p><strong>Type:</strong> {data.discount_type}</p>
            <p><strong>Value:</strong> ₹{data.value.toLocaleString()}</p>
            <p><strong>Status:</strong> {data.status}</p>
            <p><strong>Ends On:</strong> {new Date(data.end_date).toLocaleString()}</p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewDeal;
